module.exports = __webpack_public_path__ + "media/images/sampleBet__deco-24b5adf034fc4c3f929fa923eebf1e0a.png";